import { createSlice } from "@reduxjs/toolkit"

export const campaignFiltersSlice = createSlice({
  name: "campaignFilters",
  initialState: {
    filters: {
      platform: "",
      step: "",
      created_at_start: "",
      created_at_end: "",
      visibility: "",
      gender: "",
      country: "",
      barter: "",
      deleted: "false",
      max_follower: "",
      min_follower: "",
      max_age: "",
      min_age: "",
      max_cost: "",
      campaignName: "",
      classification: "",
    },
  },
  reducers: {
    setCampaignFilters: (state, action) => {
      state.filters = action.payload
    },
  },
})

export const { setCampaignFilters } = campaignFiltersSlice.actions

export const selectCampaignFilters = (state: any) => state.campaignFilters.filters

export default campaignFiltersSlice.reducer
